export enum KioskItemCardStyleEnum {
  SMALL = 0,
  MEDIUM = 1,
  LARGE = 2,
}

export enum KioskMenuBackgroundColorStyleEnum {
  SYSTEM = 0,
  CUSTOM = 1,
}

export enum StaticPaymentMethodsEnum {
  CASH = 0,
  CARD = 1,
}
